import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '~utils/helpers';
import AlertBar from './AlertBar';
import { HTMLContent } from '../Content';

function StateAlerts({ stateInfo, showRegistrationAlerts, showVbmAlerts }) {
  return (
    <div id='state-alerts'>
      {/* Note: Only show warnings/alerts if they exist */}
      {showRegistrationAlerts && stateInfo.warnings_registration.text && (
        <AlertBar alertType='warning'>
          <HTMLContent
            content={capitalize(stateInfo.warnings_registration.html)}
          />
        </AlertBar>
      )}
      {showVbmAlerts && stateInfo.warnings_absentee.text && (
        <AlertBar alertType='warning'>
          <HTMLContent content={stateInfo.warnings_absentee.html} />
        </AlertBar>
      )}
      {showRegistrationAlerts && stateInfo.alerts_registration.text && (
        <AlertBar alertType='info'>
          <HTMLContent
            content={capitalize(stateInfo.alerts_registration.html)}
          />
        </AlertBar>
      )}
      {showVbmAlerts && stateInfo.alerts_absentee.text && (
        <AlertBar alertType='info'>
          <HTMLContent content={stateInfo.alerts_absentee.html} />
        </AlertBar>
      )}
    </div>
  );
}

StateAlerts.propTypes = {
  stateInfo: PropTypes.object.isRequired,
  showRegistrationAlerts: PropTypes.bool,
  showVbmAlerts: PropTypes.bool,
};

StateAlerts.defaultProps = {
  showRegistrationAlerts: false,
  showVbmAlerts: false,
};

export default StateAlerts;
